import React from "react";

/*
========================================================
BILLING STATUS CARD
--------------------------------------------------------
Purpose:
- Displays current billing status for tenant
========================================================
*/

function titleCase(value) {
  if (!value) return "—";
  return String(value).charAt(0).toUpperCase() + String(value).slice(1);
}

export default function BillingStatusCard({ status }) {
  const cardStyle = {
    background: "#13293d",
    borderRadius: 12,
    padding: 20,
    border: "1px solid rgba(255,255,255,0.08)",
    marginBottom: 20,
  };

  return (
    <div style={cardStyle}>
      <h2 style={{ marginTop: 0 }}>Current Billing Status</h2>

      <div style={{ display: "grid", gridTemplateColumns: "220px 1fr", rowGap: 10 }}>
        <div style={{ color: "#9fb0c3" }}>Subscription Plan</div>
        <div>{titleCase(status?.subscription_plan)}</div>

        <div style={{ color: "#9fb0c3" }}>Subscription Status</div>
        <div>{titleCase(status?.subscription_status)}</div>

        <div style={{ color: "#9fb0c3" }}>Subscription Ends</div>
        <div>{status?.subscription_ends_at || "—"}</div>

        <div style={{ color: "#9fb0c3" }}>Billing Email</div>
        <div>{status?.billing_email || "—"}</div>

        <div style={{ color: "#9fb0c3" }}>Billing Name</div>
        <div>{status?.billing_name || "—"}</div>
      </div>
    </div>
  );
}
